import http from '@/services/http';

export interface TrackLyricsPayload {
  id: number;
  lyrics_body: string | null;
  language: string | null;
  source_name: string | null;
  source_reference: string | null;
  fetched_title: string | null;
  fetched_artist: string | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface LyricsCheckStatusOption {
  id: number;
  name: string;
}

export interface LiveTrackLyricsQueryResult {
  lyrics: TrackLyricsPayload | null;
  fetchPending: boolean;
  lyricsCheckStatusId: number | null;
  lyricsCheckStatuses: LyricsCheckStatusOption[];
  /** Present when the current user is a developer (`meta.lyrics_fetch_last_job_log`). */
  lyricsFetchLastJobLog: string | null;
}

export async function fetchLiveTrackLyrics(liveTrackId: number): Promise<LiveTrackLyricsQueryResult> {
  const response = await http.get<{
    data: TrackLyricsPayload | null;
    meta?: {
      lyrics_fetch_pending?: boolean;
      lyrics_check_status_id?: number | null;
      lyrics_check_statuses?: LyricsCheckStatusOption[];
      lyrics_fetch_last_job_log?: string | null;
    };
  }>(`/api/live_track/${liveTrackId}/lyrics`);

  return {
    lyrics: response.data.data ?? null,
    fetchPending: response.data.meta?.lyrics_fetch_pending ?? false,
    lyricsCheckStatusId: response.data.meta?.lyrics_check_status_id ?? null,
    lyricsCheckStatuses: response.data.meta?.lyrics_check_statuses ?? [],
    lyricsFetchLastJobLog: response.data.meta?.lyrics_fetch_last_job_log ?? null,
  };
}
